<form [formGroup]="form" (ngSubmit)="onSubmit()">
    <app-ibase-cru-modal-content
        [showDefaultFormFooter]="true"
        updateButtonLabel="Rename"
        [contentClasses]="['floatingLabelContainer']"
    >
        <p-floatlabel variant="on">
            <input id="name" type="text" pInputText formControlName="name" />
            <label for="name">File Name</label>
        </p-floatlabel>
    </app-ibase-cru-modal-content>
</form>
